import { ColDef, GridReadyEvent } from "ag-grid-community";
import { RootState } from "../../../../Redux/store";
import styles from "./PaymentHistory.module.scss";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";

interface PaymentHistoryType {
  paymentDate: string;
  invoiceDescription: string;
  amount: number;
  cardNum: string;
}

const columnDefs: ColDef<PaymentHistoryType>[] = [
  {
    headerName: "Date",
    field: "paymentDate",
    minWidth: 100,
    sort: "desc",
    valueGetter: (params) => {
      return moment(params?.data?.paymentDate).format("MM/DD/YYYY");
    },
  },
  {
    headerName: "Description",
    field: "invoiceDescription",
    minWidth: 250,
  },
  {
    headerName: "Amount",
    field: "amount",
    minWidth: 100,
    valueFormatter: (params) => `$${params.value.toFixed(2)}`,
  },
  {
    headerName: "Payment Method",
    field: "cardNum",
    minWidth: 150,
    valueGetter: (params) => {
      return `Card-${params?.data?.cardNum}`;
    },
  },
];

const defaultColDef: ColDef = {
  resizable: true,
  sortable: true,
  filter: false,
  wrapText: true,
  autoHeight: true,
  unSortIcon: true,
};

function PaymentHistory() {
  const { profileData } = useSelector((state: RootState) => state.profile);
  const [rowData, setRowData] = useState<PaymentHistoryType[]>([]);
  const [gridApi, setGridApi] = useState<any>(null);

  const onGridReady = (params: GridReadyEvent) => {
    setGridApi(params.api);
    params.api.sizeColumnsToFit();
  };

  useEffect(() => {
    if (!gridApi) return;

    const handleResize = () => {
      gridApi.sizeColumnsToFit();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [gridApi]);

  useEffect(() => {
    if (profileData) {
      setRowData(profileData?.payments);
    }
  }, [profileData]);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.gridContainer}>
        <AgGridReact
          className={styles.grid}
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          onGridReady={onGridReady}
          pagination={true}
          paginationPageSize={10}
          paginationPageSizeSelector={[5, 10, 20, 50, 100]}
          animateRows={true}
          domLayout="autoHeight"
        />
      </div>
    </div>
  );
}

export default PaymentHistory;
